import { Card, Tab, Tabs, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Icon } from "@material-ui/core";
import MDBox from "components/MDBox";
import AlertView from "./AlertView";
import LocationView from "./LocationView";
import TrainView from "./TrainView";
import DefaultView from "./DefaultView";
import AlarmList from "./AlarmList";
import googleMapView from "./GoogleMapView";
import { useMaterialUIController } from "context";
import CommunicationView from "./CommunicationView";
import UserActivityLog from "application/modules/userActivityLog";
import DeviceAlert from "./deviceAlertView";
import AuthenticationService from "application/modules/authentication/AuthenticationService";

export default function Suraksha({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
}) {
  const [isDisable, setIsDisable] = useState(false);
  const [isGoogleMap, setIsGoogleMap] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Default");

  const [controller] = useMaterialUIController();
  const { activePage } = controller;

  const Attributes = {
    enableSelectDispatcherMenu: true,
    keyField: "department",
    label: "Select Department",
    value: AuthenticationService.getDepartmentList(),
    modes: [],
  };

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks && registerCallBacks({});

    const result = AuthenticationService.allowMCXDispatcher();
    if (result !== undefined && result !== null) {
      setIsDisable(result);
    }

    const mapURL = AuthenticationService.getMapUrl();
    const isGoogle = mapURL?.toLowerCase().includes("googlemap");
    setIsGoogleMap(isGoogle);
    setSelectedTab(isGoogle ? "GoogleMap" : "Default");
  }, [activePage]);

  const getTabs = () => [
    {
      label: "Default View",
      value: "Default",
      icon: "view_cozy",
      component: DefaultView,
    },
    {
      label: "Default Map View",
      value: "GoogleMap",
      icon: "map",
      component: googleMapView,
    },
    {
      label: "Train View",
      value: "Train",
      icon: "train",
      component: TrainView,
      disabled: () => isDisable,
    },
    {
      label: "Location View",
      value: "Location",
      icon: "place",
      component: LocationView,
      disabled: () => isDisable,
    },
    {
      label: "Device Alert View",
      value: "DeviceAlert",
      icon: "security",
      component: DeviceAlert,
    },
    {
      label: "Alert View",
      value: "Alert",
      icon: "warning_amber",
      component: AlertView,
      disabled: () => isDisable,
    },
    {
      label: "SOS Alarm List",
      value: "Alarm",
      icon: "access_alarm",
      component: AlarmList,
    },
    {
      label: "Event List",
      value: "Event",
      icon: "event",
      component: UserActivityLog,
      disabled: () => isDisable,
    },
    {
      label: "Communication View",
      value: "Communication",
      icon: "phone_in_talk",
      component: CommunicationView,
      disabled: () => isDisable,
    },
  ];

  const TABS = getTabs();
  const CurrentView = TABS.find((tab) => tab.value === selectedTab)?.component;

  return (
    <MDBox>
      <Grid container spacing={1}>
        {/* ---------- Stylish Tabs Section ---------- */}
        <Grid item xs={12}>
          <Card
            sx={{
              borderRadius: "14px",
              px: 0,
              py: 0,
              boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
            }}
          >
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 40,

                "& .MuiTabs-indicator": {
                  display: "none",
                },

                "& .MuiTabs-flexContainer": {
                  gap: "6px",
                  alignItems: "center",
                },

                "& .MuiTab-root": {
                  textTransform: "none",
                  minHeight: 40,
                  fontSize: "13.5px",
                  fontWeight: 500,
                  borderRadius: "10px",
                  padding: "8px 14px",
                  color: "#5f6b7a",
                  transition: "all 0.25s ease",
                  backgroundColor: "transparent",
                  display: "flex",
                  flexDirection: "row",
                  gap: "6px",

                  "& .MuiTab-iconWrapper": {
                    marginBottom: "0px !important",
                  },

                  "&:hover": {
                    backgroundColor: "rgba(52,146,235,0.08)",
                    color: "#3492eb",
                  },
                },

                "& .Mui-selected": {
                  color: "#fff !important",
                  background: "linear-gradient(135deg,#3492eb 0%,#1c6ed5 100%)",
                  boxShadow: "0 4px 10px rgba(52,146,235,0.35)",
                },

                "@media (max-width: 600px)": {
                  "& .MuiTab-root": {
                    fontSize: "12px",
                    padding: "6px 10px",
                  },
                },
              }}
            >
              {TABS.filter((tab) => {
                if (isGoogleMap && tab.value === "Default") return false;
                if (!isGoogleMap && tab.value === "GoogleMap") return false;
                return !tab.disabled?.();
              }).map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  icon={<Icon>{tab.icon}</Icon>}
                  iconPosition="start"
                />
              ))}
            </Tabs>
          </Card>
        </Grid>

        {/* ---------- View Section ---------- */}
        {CurrentView && (
          <Grid item xs={12}>
            <CurrentView
              onLoad={onLoad}
              pageId={pageId}
              searchText={searchText}
              registerCallBacks={registerCallBacks}
            />
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
}
